/**
 * @file
 * Karhu Helsinki theme javascripts
 */

(function ($, Drupal, drupalSettings) {

  "use strict";

  var windowWidth = function(){
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
  }

  Drupal.behaviors.trestonIndexedVariations = {
  	firstShot: false,
    attach: function(context, settings) {
    	//Facets
      $('.block-product-version .views .option',context).each(function( i, facets ){
        if( windowWidth() < drupalSettings.breakpoints["treston.large"] ){
          if( !Drupal.behaviors.trestonIndexedVariations.firstShot ){
            $( facets ).toggleClass('open');
            Drupal.behaviors.trestonIndexedVariations.firstShot = true;
          }
          facets.getElementsByTagName('h2')[0].addEventListener('click',function(e){
            $( '.option', e.target.parentElement.parentElement ).removeClass('open');
            $( e.target.parentElement ).toggleClass('open');
          });
        }
      });
    }
  }

})(jQuery, Drupal, drupalSettings);